import { createActions } from 'redux-actions'

export const {
  toast: {
    clear: clearToast
  }
} = createActions({
  TOAST: {
    CLEAR: () => ({})
  }
})
